export default {
    localStorageKey: 'cm_user',
    setUser: function (user) {
        localStorage.setItem(this.localStorageKey, JSON.stringify(user));
    },
    deleteUser: function () {
        window.localStorage.removeItem(this.localStorageKey);
    },
    isLogged: function () {
        let user = this.getUser();
        if (!user) {
            return false;
        }

        return !!user.token;

    },
    getUser: function () {
        let user = JSON.parse(window.localStorage.getItem(this.localStorageKey));
        if (!user) {
            return false;
        }
        return user;
    }
};

